const CoursesData = [
  {
    id: 1,
    imaageURL: "laptop-1",
    name: "Basics of JAVA",
    level: "Beginner Level",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully",
    price: "125.65",
  },

  {
    id: 2,
    imaageURL: "tab",
    name: "OOP Fundamentals",
    level: "Beginner Level",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully",
    price: "15.65",
  },

  {
    id: 3,
    imaageURL: "computer-setup",
    name: "Into to UI/UX",
    level: "Beginner Level",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully",
    price: "16.58",
  },

  {
    id: 4,
    imaageURL: "gaming",
    name: "UI Certification",
    level: "Beginner Level",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully",
    price: "45.15",
  },

  {
    id: 5,
    imaageURL: "laptop-1",
    name: "UX Certification",
    level: "Beginner Level",
    info: "Java is a class-based object-oriented simple programming language. Though we can not consider it to be fully",
    price: "45.15",
  },
]

export default CoursesData;